import React from 'react';
import { Button } from './ui/Button';
import { Check } from 'lucide-react';
export function Hero() {
  const benefits = ['Menos peleas, más tranquilidad a la hora de cenar', 'Una sola preparación para toda la familia', 'Decisiones resueltas antes de que empiece el cansancio'];
  return <section className="relative pt-12 pb-16 px-4 md:pt-24 md:pb-28 overflow-hidden bg-[#FDFBF9]" data-id="element-136">
      <div className="max-w-4xl mx-auto text-center" data-id="element-137">
        {/* Headline */}
        <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-[#2E2E2E] mb-6 leading-tight tracking-tight" data-id="element-138">
          Hoy cenamos sin negociar
        </h1>

        {/* Subheadline */}
        <p className="text-lg md:text-xl text-[#2E2E2E]/80 mb-10 leading-relaxed max-w-3xl mx-auto" data-id="element-139">
          30 cenas argentinas, simples y repetibles + menús semanales + listas
          de compras, para que dejes de cocinar doble y la cena vuelva a ser un
          trámite.
        </p>

        {/* Product Image - Below subtitle */}
        <div className="relative mb-10 max-w-2xl mx-auto" data-id="element-140">
          <div className="relative rounded-2xl overflow-hidden shadow-2xl border border-[#2E2E2E]/5 bg-white" data-id="element-141">
            <img src="https://cdn.magicpatterns.com/uploads/m5wiMZtwkMwFHwkXA4FZEN/gemini-generated-image-1769781395483.png" alt="30 Cenas Anti-Pelea - Ebook + Bonos en tablet y celular" className="w-full h-auto object-cover" data-id="element-142" />
          </div>

          {/* Subtle decorative elements */}
          <div className="hidden md:block absolute -bottom-6 -right-6 w-48 h-48 bg-[#F6EEDC] rounded-full -z-10 opacity-70" data-id="element-143"></div>
          <div className="hidden md:block absolute -top-6 -left-6 w-32 h-32 bg-[#0D3B66]/5 rounded-full -z-10" data-id="element-144"></div>
        </div>

        {/* Benefits */}
        <ul className="space-y-3 mb-8 text-left max-w-md mx-auto" data-id="element-145">
          {benefits.map((benefit, index) => <li key={index} className="flex items-start" data-id="element-146">
              <Check className="w-5 h-5 text-[#0D3B66] mr-3 mt-0.5 flex-shrink-0" data-id="element-147" />
              <span className="text-[#2E2E2E]/80 text-base" data-id="element-148">{benefit}</span>
            </li>)}
        </ul>

        {/* CTA */}
        <div className="flex flex-col items-center gap-3" data-id="element-149">
          <Button variant="secondary" icon onClick={() => document.getElementById('pricing')?.scrollIntoView({
          behavior: 'smooth'
        })} className="text-lg px-8 py-4" data-id="element-150">
            Quiero el PDF ahora
          </Button>

          <p className="text-sm text-[#2E2E2E]/50" data-id="element-151">
            Descarga inmediata · Formato digital
          </p>

          {/* Social proof badge */}
          <div className="mt-4 inline-flex items-center gap-2 bg-[#8B9F3A]/10 text-[#6B7A2E] text-sm font-medium px-4 py-2 rounded-full" data-id="element-152">
            <span className="w-2 h-2 bg-[#8B9F3A] rounded-full" data-id="element-153"></span>
            Más de 5,000 personas ya lo probaron
          </div>
        </div>
      </div>
    </section>;
}